import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import missileIcon from '../../../images/shared/missile.svg';

import './index.scss';

function FormSuccessMsg({ message }) {
  return (
    <div className="w-100 h-100 f-v-center max-w-700">
      <p>
        {message.map((t, index) => (
          <Fragment key={t}>
            <span
              className={`f60 f40-med f30-m text-darkBlue ${
                index % 2 === 0 ? 'regular' : 'bold'
              }`}
            >
              {`${t} `}
            </span>
          </Fragment>
        ))}
        <img src={missileIcon} alt="" className="ms-8" />
      </p>
    </div>
  );
}

FormSuccessMsg.propTypes = {
  message: PropTypes.shape.isRequired,
};

FormSuccessMsg.defaultProps = {};

export default FormSuccessMsg;
